var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSvhOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 122,
    viewBox: "0 0 280 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1102_5080)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9999 10C32.1634 10 24.9999 17.1634 24.9999 26V40.1831L10.2962 54.7326C9.77655 55.2468 10.1445 55.9292 10.9786 55.9984L24.9999 57.1613V96C24.9999 104.837 32.1634 112 40.9999 112H254C262.837 112 270 104.837 270 96V26C270 17.1634 262.837 10 254 10H40.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 40.1831L26.055 41.2494L26.4999 40.8091V40.1831H24.9999ZM10.2962 54.7326L11.3512 55.7989L11.3512 55.7989L10.2962 54.7326ZM10.9786 55.9984L10.8546 57.4932H10.8546L10.9786 55.9984ZM24.9999 57.1613H26.4999V55.7806L25.1239 55.6664L24.9999 57.1613ZM26.4999 26C26.4999 17.9919 32.9918 11.5 40.9999 11.5V8.5C31.335 8.5 23.4999 16.335 23.4999 26H26.4999ZM26.4999 40.1831V26H23.4999V40.1831H26.4999ZM11.3512 55.7989L26.055 41.2494L23.9449 39.1169L9.24111 53.6664L11.3512 55.7989ZM11.1026 54.5035C11.0418 54.4985 11.2773 54.5001 11.4501 54.8205C11.5399 54.9872 11.5807 55.1983 11.541 55.4118C11.5022 55.6202 11.4035 55.7471 11.3512 55.7989L9.24111 53.6664C8.57316 54.3273 8.32084 55.3381 8.80941 56.2442C9.24478 57.0517 10.0812 57.4291 10.8546 57.4932L11.1026 54.5035ZM25.1239 55.6664L11.1026 54.5035L10.8546 57.4932L24.876 58.6562L25.1239 55.6664ZM26.4999 96V57.1613H23.4999V96H26.4999ZM40.9999 110.5C32.9918 110.5 26.4999 104.008 26.4999 96H23.4999C23.4999 105.665 31.335 113.5 40.9999 113.5V110.5ZM254 110.5H40.9999V113.5H254V110.5ZM268.5 96C268.5 104.008 262.008 110.5 254 110.5V113.5C263.665 113.5 271.5 105.665 271.5 96H268.5ZM268.5 26V96H271.5V26H268.5ZM254 11.5C262.008 11.5 268.5 17.9919 268.5 26H271.5C271.5 16.335 263.665 8.5 254 8.5V11.5ZM40.9999 11.5H254V8.5H40.9999V11.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1102_5080",
    x: 0.554688,
    y: 0.5,
    width: 278.945,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.365319 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1102_5080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1102_5080",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSvhOne);
export default __webpack_public_path__ + "static/media/message_svh_one.c25f8368c3ebc21d07380809b7f4bcff.svg";
export { ForwardRef as ReactComponent };